<template>
  <model-form
    ref="modelForm"
    :model="newsItem"
  >
    <div class="q-gutter-sm">
      <div class="row q-col-gutter-md items-start">
        <model-form-input
          field="title"
          class="col-10"
          label="Title"
          :rules="[val => !!val || 'Field is required']"
          autofocus
        />
        <model-form-toggle
          field="published"
          class="col-2"
          label="Published"
        />
      </div>
      <div class="row q-col-gutter-md items-start">
        <model-form-select
          field="newsItemClass"
          class="col-4"
          label="News Item Class"
          :options="newsItemClasses.data"
          option-label="name"
          emit-value
          :rules="[val => !!val || 'Field is required']"
        />
        <model-form-input
          field="subtitle"
          class="col-4"
          label="Subtitle"
        />
        <div class="col-4 q-py-none q-my-auto">
          <div
            class="q-pa-sm text-body2"
            style="border: solid 2px; height: 40px; border-radius: 4px; cursor: pointer;"
            :style="'color: ' + newsItem.color + '; border-color: ' + newsItem.color + '; background-color: ' + newsItem.color + '33;'"
          >
            <div class="ellipsis">
              {{ newsItem.subtitle }}
            </div>
            <q-menu
              anchor="top left"
              self="top left"
            >
              <q-color v-model="newsItem.color" />
            </q-menu>
          </div>
        </div>
        <model-form-input
          field="description"
          class="col-12"
          label="Description"
        />
      </div>
      <div class="row q-col-gutter-md items-start q-mt-xs">
        <model-form-input
          field="startDate"
          class="col-6"
          label="Start Date"
          clearable
          :rules="[
            () => !newsItem.startDate || !newsItem.endDate || newsItem.startDate <= newsItem.endDate || 'Date cannot postdate end date',
          ]"
        />
        <model-form-input
          field="endDate"
          class="col-6"
          label="End Date"
          clearable
          :rules="[
            () => !newsItem.endDate || !newsItem.startDate || newsItem.endDate >= newsItem.startDate || 'Date cannot predate start date',
          ]"
        />
        <model-form-toggle
          field="hasLink"
          class="col-2"
          label="Has Link"
        />
        <model-form-input
          v-if="newsItem.hasLink"
          field="buttonText"
          class="col-4"
          label="Button Text"
          :rules="[val => !!val || 'Field is required']"
        />
        <model-form-input
          v-if="newsItem.hasLink"
          field="linkUrl"
          class="col-6"
          label="Url"
          :rules="[val => !!val || 'Field is required']"
          :hint="urlValidationMessage"
        />
      </div>
      <div class="row items-start q-mt-md">
        <div class="col-6">
          Image
          <model-form-image-uploader
            field="image"
            :image-url="newsItem.imageUrl"
          />
        </div>
      </div>
      <div class="row items-start">
        <h5>Website Preview</h5>
      </div>
      <div class="row items-start">
        <div class="col-12">
          <news-carousel :news-items="[newsItem]" />
        </div>
      </div>
      <div class="row items-start">
        <h5>App Preview</h5>
      </div>
      <div class="row items-start">
        <div class="col-4">
          <news
            :demo-news-items="[newsItem]"
            :admin="true"
          />
        </div>
      </div>
    </div>
  </model-form>
</template>

<script>
import { date } from 'quasar'
import { IsoDate } from 'src/models/model'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import NewsCarousel from 'src/modules/consumer/components/NewsCarousel'
import News from 'src/modules/consumer/pages/News'

export default {
  name: 'NewsItemForm',
  configuration: ['newsItemClasses'],
  components: {
    ModelForm,
    NewsCarousel,
    News
  },
  data () {
    return {
      urlValidationMessage: null
    }
  },
  watch: {
    'newsItem.linkUrl' () {
      this.validateUrl()
    }
  },
  created () {
    _.extend(this, { date, IsoDate })
  },
  models: {
    newsItem: {
      newsItemClass: 'default',
      // This is here so we fetch it on save so it
      // will show up in the new items table without
      // having to reload it, making use of apollo
      // subscriptions
      visible: 'default'
    }
  },
  methods: {
    show (model, initialData) {
      this.$refs.modelForm.show(model, initialData)
    },
    validateUrl () {
      const urlErrorMessage = this.$mh.foundNetlifyUrl(this.newsItem.linkUrl)
      if (urlErrorMessage) {
        this.urlValidationMessage = `Url contains ${urlErrorMessage}`
      } else {
        this.urlValidationMessage = null
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .banner-img {
    width: 100%;
  }
</style>
